import { C as r, e as s } from "./custom-element-BInKsiaT.js";
class a extends r {
  [Symbol.toStringTag] = "FlipFlop";
  constructor() {
    super();
  }
  connectedCallback() {
    this.state.add("current", 0), this.querySelector("[data-flipper]")?.addEventListener("click", () => {
      this.state.current.set(this.state.current.get() ^ 1);
    }), this.querySelectorAll("[data-item]").forEach((t, e) => {
      this.effects.push(
        s(() => {
          e === this.state.current.get() ? t.setAttribute("aria-current", "true") : t.removeAttribute("aria-current");
        })
      );
    });
  }
}
customElements.define("flip-flop", a);
